<template>
    <div>
    
      <chanpin  page_type="1" chanpin_type="3" user_type="2" > </chanpin> 
    </div>
  </template>
  <script>
  import chanpin from '../../tongyong/chanpin.vue'
   
  export default {
  
    components: {
      chanpin: chanpin 
    },
  
    data() {
      return {
        // 获取用户列表参数
        
      };
    },
    props: [],
   
    watch: {
   
    },
    created() {
   
    },
    mounted() {
   
    }
  }
  </script>
